class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.updateReassurance();

    if (this.header) this.header.reveal();
    this.open();
  }

  updateReassurance() {
    const reassurance = this.querySelector('.twc-cart-notification__reassurance');
    const product = document.getElementById('cart-notification-product');
    if (!reassurance || !product) return;

    const primary = reassurance.querySelector('[data-twc-cart-reassurance-primary]');
    const secondary = reassurance.querySelector('[data-twc-cart-reassurance-secondary]');
    if (!primary || !secondary) return;

    const orderTypeRow = Array.from(product.querySelectorAll('.product-option')).find((row) => {
      const label = row.querySelector('dt')?.textContent?.replace(':', '').trim().toLowerCase();
      return label === 'roll or sample';
    });
    const orderType = orderTypeRow?.querySelector('dd')?.textContent?.trim().toLowerCase();

    if (orderType === 'roll') {
      primary.textContent = 'Made to order in 2–5 days';
      secondary.textContent = 'Delivery calculated at checkout';
    } else if (orderType === 'sample') {
      primary.textContent = 'Check colour & finish at home';
      secondary.textContent = 'Delivery calculated at checkout';
    } else {
      primary.textContent = 'Secure checkout';
      secondary.textContent = 'Delivery calculated at checkout';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
